/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCodeDownload = (props: Props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <g fill="none">
      <path
        d="M9.931 8.732 8.47 7.368 3.632 12.55l4.837 5.182 1.462-1.364-3.563-3.818 3.563-3.818zm4.139 0 3.562 3.818-3.563 3.818 1.462 1.364 4.837-5.182-4.837-5.182-1.462 1.364zm5.137 7.818v3.586l-1.293-1.293-1.414 1.414 3.707 3.707 3.707-3.707-1.414-1.414-1.293 1.293V16.55h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCodeDownload as CodeDownload };
